import { render, staticRenderFns } from "./Cropexpectation.vue?vue&type=template&id=239f16e2&scoped=true&"
import script from "./Cropexpectation.vue?vue&type=script&lang=js&"
export * from "./Cropexpectation.vue?vue&type=script&lang=js&"
import style0 from "./Cropexpectation.vue?vue&type=style&index=0&id=239f16e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239f16e2",
  null
  
)

export default component.exports